import { Box, styled } from '@mui/material';

export const StyledFooter = styled(Box)(({ theme }) => ({
    position: 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 4,
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    padding: theme.spacing(0),
}));
